import { render, staticRenderFns } from "./TNoContentPanel.vue?vue&type=template&id=c6ff816e&scoped=true&"
import script from "./TNoContentPanel.vue?vue&type=script&lang=js&"
export * from "./TNoContentPanel.vue?vue&type=script&lang=js&"
import style0 from "./TNoContentPanel.vue?vue&type=style&index=0&id=c6ff816e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ff816e",
  null
  
)

/* custom blocks */
import block0 from "./TNoContentPanel.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports